import { FormattedMessage } from 'react-intl';
import { Col, Grid, Modal, Row } from 'rsuite';

import { OpenModal } from '../../../containers/styled/alerts';
import { ViewMarginDiv } from '../../../containers/styled/layout';
import { StyledModalDivider } from '../../../containers/styled/styled';
import {
  H5,
  ViewLabel,
  ViewLabelValue
} from '../../../containers/styled/typography';
import AuditFieldsView from '../../generic/AuditFieldsView';

/**
 * Processing View screen
 *
 * Processing view to display each processing in-detail.
 *
 * @component
 * @param {object} item              prop used to prepopulate the form fields with data when editing
 * @param {boolean} handleClose      handles modal close event
 * @returns processing view modal.
 *
 */
const ProcessingView = ({ item, handleClose }) => (
  <OpenModal
    onClose={handleClose}
    size='md'
    title={
      <FormattedMessage
        id='processing.details.title'
        defaultMessage='Processing Result Information'
      />
    }
  >
    <Modal.Body style={{ marginBottom: 30 }}>
      <Grid fluid>
        <Row>
          <Col xs={12}>
            <ViewLabel>
              <FormattedMessage
                id='processing.view.label.donor.code'
                defaultMessage='Donor Code'
              />
            </ViewLabel>
            <ViewLabelValue>{item.donorCode}</ViewLabelValue>
          </Col>
          <Col xs={12}>
            <ViewLabel>
              <FormattedMessage
                id='processing.view.label.facility'
                defaultMessage='Facility'
              />
            </ViewLabel>
            <ViewLabelValue>{item.facility}</ViewLabelValue>
          </Col>
        </Row>
        <ViewMarginDiv />
        <H5>
          <FormattedMessage
            id='processing.view.details.processingInformation'
            defaultMessage='Processing Information'
          />
        </H5>
        <StyledModalDivider />
        <Row>
          <Col xs={12}>
            <ViewLabel>
              <FormattedMessage
                id='processing.view.label.dueDate'
                defaultMessage='Due Date'
              />
            </ViewLabel>
            <ViewLabelValue>{item.dueTime}</ViewLabelValue>
          </Col>
          <Col xs={12}>
            <ViewLabel>
              <FormattedMessage
                id='processing.view.label.status'
                defaultMessage='Status'
              />
            </ViewLabel>
            <ViewLabelValue>{item.status}</ViewLabelValue>
          </Col>
        </Row>
        <ViewMarginDiv />
        <H5>
          <FormattedMessage
            id='processing.view.details.bloodProductDerived'
            defaultMessage='Blood Product Derived'
          />
        </H5>
        <StyledModalDivider />
        <Row>
          <Col xs={12}>
            <ViewLabel>
              <FormattedMessage
                id='processing.view.label.bloodProduct'
                defaultMessage='Blood Product'
              />
            </ViewLabel>
            <ViewLabelValue>{item.name}</ViewLabelValue>
          </Col>
          <Col xs={12}>
            <ViewLabel>
              <FormattedMessage
                id='processing.view.label.volume'
                defaultMessage='Volume'
              />
            </ViewLabel>
            <ViewLabelValue>{item.volume}</ViewLabelValue>
          </Col>
        </Row>
        <ViewMarginDiv />
        <H5>
          <FormattedMessage
            id='processing.view.details.healthWorkerInformation'
            defaultMessage='Health Worker Information'
          />
        </H5>
        <StyledModalDivider />
        <Row>
          <Col xs={24}>
            <ViewLabel>
              <FormattedMessage
                id='processing.view.label.healthWorkerName'
                defaultMessage='Name'
              />
            </ViewLabel>
            <ViewLabelValue>{item.healthCareWorkers}</ViewLabelValue>
          </Col>
        </Row>
        <ViewMarginDiv />
        <H5>
          <FormattedMessage
            id='processing.view.details.equipmentConsumables'
            defaultMessage='Equipment & Consumables'
          />
        </H5>
        <StyledModalDivider />
        <Row>
          <Col xs={12}>
            <ViewLabel>
              <FormattedMessage
                id='processing.view.label.equipments'
                defaultMessage='Equipments'
              />
            </ViewLabel>
            {item.equipments !== 'N/A'
              ? (
                  item.equipments.map((data, index) => {
                    return <ViewLabelValue style={{ lineHeight: '10px' }} key={index}>{data.name}</ViewLabelValue>;
                  })
                )
              : (
                <ViewLabelValue>
                  <FormattedMessage
                    id='processing.view.label.equipments.notApplicable'
                    defaultMessage='N/A'
                  />
                </ViewLabelValue>
                )}
          </Col>
          <Col xs={12}>
            <ViewLabel>
              <FormattedMessage
                id='processing.view.label.consumables'
                defaultMessage='Consumables'
              />
            </ViewLabel>
            {item.consumables !== 'N/A'
              ? (
                  item.consumables.map((data, index) => {
                    return <ViewLabelValue style={{ lineHeight: '10px' }} key={index}>{data.name}</ViewLabelValue>;
                  })
                )
              : (
                <ViewLabelValue>
                  <FormattedMessage
                    id='processing.view.label.consumables.notApplicable'
                    defaultMessage='N/A'
                  />
                </ViewLabelValue>
                )}
          </Col>
        </Row>
        <ViewMarginDiv />
      </Grid>
      <H5>
        <FormattedMessage
          id='processing.view.details.otherInformation'
          defaultMessage='Other Information'
        />
      </H5>
      <StyledModalDivider />
      <AuditFieldsView item={item} />
    </Modal.Body>
  </OpenModal>
);

export default ProcessingView;
